module.exports = __webpack_public_path__ + "static/important-car-loan-2d49c89a144df99819d7b1e624ba72f1.jpg";